import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NosotrosComponent } from './pages/nosotros/nosotros.component';
import { HomeNewComponent } from './pages/home-new/home-new.component';
import { NoticiasNewComponent } from './pages/noticias-new/noticias-new.component';
import { EnvivoNewComponent } from './pages/envivo-new/envivo-new.component';
import { SuscribeteNewComponent } from './pages/suscribete-new/suscribete-new.component';
import { NoticiaNewComponent } from './pages/noticia-new/noticia-new.component';
import { RadioNewComponent } from './components/radio-new/radio-new.component';


const routes: Routes = [
  { path: '', component:  HomeNewComponent},
  { path: 'suscribete', component: SuscribeteNewComponent},
  { path: 'noticias', component:  NoticiasNewComponent},
  { path: 'noticias/:id', component:  NoticiasNewComponent},
  { path: 'noticia/:id', component:  NoticiaNewComponent},
  { path: 'nosotros', component:  NosotrosComponent},
  { path: 'envivo', component:  EnvivoNewComponent},
  { path: 'radio', component:  RadioNewComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
